import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/@bootstrap/services/store';

interface ListOpener {
    name: string;
    query_path: string;
    query_name: string;
}

export interface VersionInfo {
    version: string;
    build: string;
    revision: string;
}

export interface List {
    nome: string;
    isModificabile: boolean;
    campi?: { nome: string; lunghezza: number; }[];
    graphInfo?: {
        elencoGraphFieldName: string;
        categoriaElencoTypeName: string;
        categoriaElencoGraphFieldName: string;
        queryGraphFieldName: string;
        queryTypeName: string;
    };
}

interface CustomState {
    version?: Record<string, VersionInfo>;
    currentList?: ListOpener;
    lists?: List[];
}

const initialState: CustomState = {
};

export const customReducer = createSlice({
    name: 'custom',
    initialState,
    reducers: {
        setVersionInfo: (state, action: PayloadAction<Record<string, VersionInfo> | undefined>) => {
            state.version = action.payload;
        },
        manageList: (state, action: PayloadAction<ListOpener | undefined>) => {
            state.currentList = action.payload;
        },
        setLists: (state, action: PayloadAction<List[] | undefined>) => {
            state.lists = action.payload;
        },
    },
});

export const { setVersionInfo, manageList, setLists } = customReducer.actions;

type State = { custom: CustomState };
export const selectVersionInfo = (state: State) => state.custom.version;
export const selectCurrentList = (state: State) => state.custom.currentList;
export const selectLists = (state: State) => state.custom.lists;

export default customReducer.reducer